<template>
  <v-row>
    <v-col cols="12" sm="12" class="pt-0">
      <v-row justify="space-between" align="center">
        <v-col cols="12" md="6">
          <h1>Маркетинг / UTM-заказы</h1>
        </v-col>
        <v-col cols="12" md="4" class="search-col">
          <v-text-field
                  v-model="search"
                  prepend-icon="mdi-magnify"
                  label="Поиск (ID заказа, клиент, телефон)"
                  single-line
                  hide-details
                  clearable
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row v-if="summary" class="mt-2" align="stretch">
        <v-col cols="12" md="3">
          <v-card outlined class="fill-height stat-card">
            <v-card-text class="pb-0">
              <div class="summary-label">Заказов с атрибуцией</div>
            </v-card-text>
            <v-card-text class="summary-body">
              <div class="summary-value">{{ formatNumber(summary.total_orders) }}</div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="3">
          <v-card outlined class="fill-height stat-card">
            <v-card-text class="pb-0">
              <div class="summary-label">Выручка</div>
            </v-card-text>
            <v-card-text class="summary-body">
              <div class="summary-value">{{ formatNumber(summary.total_revenue) }} <span class="summary-currency">UAH</span></div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="6">
          <v-card outlined class="fill-height stat-card">
            <v-card-text class="pb-0">
              <div class="summary-label">По источникам</div>
            </v-card-text>
            <v-card-text class="summary-body">
              <div v-if="summary.by_source && summary.by_source.length" class="by-source-list">
                <div v-for="row in summary.by_source" :key="row.source" class="by-source-row">
                  <span>{{ row.source || '—' }}</span>
                  <span>{{ row.orders }} зак. — {{ row.revenue }} UAH</span>
                </div>
              </div>
              <div v-else class="summary-value">—</div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-card outlined class="mt-3 pa-3">
        <v-row>
          <v-col cols="12" sm="6" md="2">
            <v-text-field
                    v-model="filters.dateFrom"
                    label="Дата от"
                    type="date"
                    outlined
                    dense
                    hide-details
                    clearable
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-text-field
                    v-model="filters.dateTo"
                    label="Дата до"
                    type="date"
                    outlined
                    dense
                    hide-details
                    clearable
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-select
                    v-model="filters.utm_source"
                    :items="options.sources"
                    label="Source"
                    outlined
                    dense
                    hide-details
                    clearable
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-select
                    v-model="filters.utm_medium"
                    :items="options.mediums"
                    label="Medium"
                    outlined
                    dense
                    hide-details
                    clearable
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-autocomplete
                    v-model="filters.utm_campaign"
                    :items="options.campaigns"
                    label="Campaign"
                    outlined
                    dense
                    hide-details
                    clearable
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-text-field
                    v-model="filters.utm_id"
                    label="UTM ID"
                    outlined
                    dense
                    hide-details
                    clearable
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-text-field
                    v-model="filters.orderId"
                    label="ID заказа"
                    outlined
                    dense
                    hide-details
                    clearable
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="2" class="d-flex align-center">
            <v-btn outlined @click="resetFilters">Сбросить фильтры</v-btn>
          </v-col>
        </v-row>
      </v-card>

      <v-alert
              v-if="error"
              type="error"
              outlined
              class="mt-3"
      >
        Не удалось загрузить данные. {{ error }}
        <v-btn text color="error" @click="fetchData">Повторить</v-btn>
      </v-alert>

      <v-data-table
              no-data-text="Нет заказов с рекламной атрибуцией"
              no-results-text="По заданному запросу ничего не найдено"
              :headers="headers"
              :items="orders"
              :options.sync="options_table"
              :header-props="{sortIcon: 'icon-custom-arrow'}"
              :footer-props="footerProps"
              :server-items-length="total"
              :loading="loading"
              :fixed-header="true"
              height="60vh"
              :items-per-page="15"
              loading-text="Загрузка UTM-заказов... Подождите пожалуйста"
              class="mt-3"
      >
        <template v-slot:item.client_id="{ item }">
          {{ item.client_id || '—' }}
        </template>
        <template v-slot:item.client_phone="{ item }">
          {{ item.client_phone || '—' }}
        </template>
        <template v-slot:item.utm_source="{ item }">
          {{ item.utm_source || '—' }}
        </template>
        <template v-slot:item.utm_medium="{ item }">
          {{ item.utm_medium || '—' }}
        </template>
        <template v-slot:item.utm_campaign="{ item }">
          {{ item.utm_campaign || '—' }}
        </template>
        <template v-slot:item.utm_content="{ item }">
          {{ item.utm_content || '—' }}
        </template>
        <template v-slot:item.utm_term="{ item }">
          {{ item.utm_term || '—' }}
        </template>
        <template v-slot:item.utm_id="{ item }">
          {{ item.utm_id || '—' }}
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
    import UtmOrderService from "../../api/UtmOrderService";

    export default {
        name: 'UtmOrderIndex',
        data: () => ({
            search: '',
            timerId: null,
            timeRequest: null,
            loading: true,
            error: '',
            orders: [],
            total: 0,
            summary: null,
            options_table: {},
            options: {
                sources: [],
                mediums: [],
                campaigns: [],
            },
            filters: {
                dateFrom: '',
                dateTo: '',
                utm_source: '',
                utm_medium: '',
                utm_campaign: '',
                utm_id: '',
                orderId: '',
            },
            footerProps: {
                itemsPerPageText: 'Заказов на страницу',
                pageText: '{0}-{1} из {2}',
                itemsPerPageAllText: 'Все',
                itemsPerPageOptions: [15, 30, -1]
            },
            headers: [
                {
                    text: 'ID заказа',
                    value: 'order_id',
                },
                {
                    text: 'ID клиента',
                    value: 'client_id',
                    sortable: false,
                },
                {
                    text: 'Телефон клиента',
                    value: 'client_phone',
                    sortable: false,
                },
                {
                    text: 'Дата заказа',
                    value: 'order_date',
                },
                {
                    text: 'Сумма',
                    value: 'order_sum',
                },
                {
                    text: 'Source',
                    value: 'utm_source',
                    sortable: false,
                },
                {
                    text: 'Medium',
                    value: 'utm_medium',
                    sortable: false,
                },
                {
                    text: 'Campaign',
                    value: 'utm_campaign',
                    sortable: false,
                },
                {
                    text: 'Content',
                    value: 'utm_content',
                    sortable: false,
                },
                {
                    text: 'Term',
                    value: 'utm_term',
                    sortable: false,
                },
                {
                    text: 'UTM ID',
                    value: 'utm_id',
                    sortable: false,
                },
            ],
        }),
        mounted() {
            UtmOrderService.options().then(response => {
                this.options.sources = response.data.sources || []
                this.options.mediums = response.data.mediums || []
                this.options.campaigns = response.data.campaigns || []
            }).catch(() => {
            })
        },
        watch: {
            options_table: {
                handler() {
                    this.fetchData()
                },
                deep: true,
            },
            filters: {
                handler() {
                    clearTimeout(this.timerId)
                    this.timerId = setTimeout(() => {
                        this.fetchData()
                    }, 400)
                },
                deep: true,
            },
            search() {
                clearTimeout(this.timerId)
                this.timerId = setTimeout(() => {
                    this.fetchData()
                }, 700)
            }
        },
        methods: {
            formatNumber(value) {
                const num = Number(value) || 0
                return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
            },
            buildParams() {
                return {
                    page: this.options_table.page,
                    perPage: this.options_table.itemsPerPage,
                    sortBy: this.options_table.sortBy && this.options_table.sortBy.length > 0 ? this.options_table.sortBy[0] : '',
                    sortDesc: this.options_table.sortBy && this.options_table.sortBy.length > 0 ? this.options_table.sortDesc[0] : '',
                    search: this.search,
                    dateFrom: this.filters.dateFrom,
                    dateTo: this.filters.dateTo,
                    utm_source: this.filters.utm_source,
                    utm_medium: this.filters.utm_medium,
                    utm_campaign: this.filters.utm_campaign,
                    utm_id: this.filters.utm_id,
                    orderId: this.filters.orderId,
                }
            },
            resetFilters() {
                this.search = ''
                this.filters = {
                    dateFrom: '',
                    dateTo: '',
                    utm_source: '',
                    utm_medium: '',
                    utm_campaign: '',
                    utm_id: '',
                    orderId: '',
                }
            },
            fetchData() {
                this.loading = true
                this.error = ''
                const timeRequest = new Date().getTime();
                this.timeRequest = timeRequest
                const params = this.buildParams()
                UtmOrderService.list(params)
                    .then(response => {
                        if (this.timeRequest === timeRequest) {
                            this.orders = response.data.data
                            this.total = response.data.total
                            this.loading = false
                        }
                    })
                    .catch(error => {
                        if (this.timeRequest === timeRequest) {
                            this.loading = false
                            this.error = error && error.response && error.response.data && error.response.data.message
                                ? error.response.data.message
                                : 'Попробуйте позже.'
                        }
                    })
                UtmOrderService.summary(params)
                    .then(response => {
                        if (this.timeRequest === timeRequest) {
                            this.summary = response.data
                        }
                    })
                    .catch(() => {
                    })
            },
        }
    }
</script>

<style lang="scss" scoped>
  .stat-card {
    display: flex;
    flex-direction: column;
  }

  .stat-card .summary-body {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-top: 8px;
  }

  .summary-label {
    font-size: 0.875rem;
    color: rgba(0, 0, 0, 0.6);
    margin-bottom: 8px;
  }

  .summary-value {
    font-size: 2rem;
    line-height: 1.2;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.87);
  }

  .summary-currency {
    font-size: 1rem;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.6);
  }

  .by-source-list {
    max-height: 140px;
    overflow-y: auto;
  }

  .by-source-row {
    display: flex;
    justify-content: space-between;
    padding: 4px 0;
    font-size: 0.95rem;
  }

  .by-source-row + .by-source-row {
    border-top: 1px solid #eeeeee;
  }
</style>
